<script lang="ts" setup>
interface Meta {
    valid: boolean;
    touched: boolean;
}

interface Props {
    label?: string;
    name: string;
    errorMessage: string;
    meta: Meta;
    labelPosition?: "top" | "left";
}

const props = withDefaults(defineProps<Props>(), {
    label: "",
    name: "",
    errorMessage: "",
    labelPosition: "top",
});
</script>

<template>
    <div :class="{ 'has-error': !!errorMessage, success: meta.valid }">
        <div class="flex" :class="{ 'flex-row items-center justify-between gap-[16px]': labelPosition === 'left', 'flex-col': labelPosition === 'top' }">
            <label :for="name" class="block text-14 line-clamp-1 uppercase !leading-normal" :class="{ '': labelPosition === 'left', '': labelPosition === 'top' }" v-html="label"></label>
            <slot></slot>
        </div>

        <div class="bg-red-100 z-[1] mt-2 flex items-center rounded-[8px] text-14" v-if="errorMessage && meta.touched">
            <span class="text-14 text-red">{{ errorMessage }}</span>
        </div>
    </div>
</template>
